import React, {useState, useEffect} from 'react';
import {Card, Grid, CardContent, Typography, Button, Dialog, DialogContent, DialogActions, DialogContentText} from "@mui/material";
import ErrorIcon from '@mui/icons-material/Error';
import styles from '../../../assets/styles/modules/EmptyBookmark.module.css'


const EmptyBookmark = () => {

    const isLogin = localStorage.getItem('access_token')
    const [open, setOpen] = useState(false);

    const agreeClick = () => {
        setOpen(false);
        window.location.replace('/login')
    };

    useEffect(()=>{
        if(isLogin === null){
            setOpen(true)
        }
    },[])

    return (
        <>
            <Grid className='bookmarkedNewsContainer' item sx={{width: '45%', marginTop:'40px' }}>
                <Card sx={{height: 826, overflow: 'auto',  boxShadow:'none'}}>
                    <CardContent className={styles.emptyCardContent}>
                        <ErrorIcon className={styles.emptyIcon}/>
                        <Typography className={styles.emptyElements}>아직 스크랩한</Typography>
                        <Typography className={styles.emptyElements}>뉴스가 없어요</Typography>
                        <Button className={styles.goNewsBtn} onClick={() => {window.location.replace('/mycorp')}}>추천뉴스 보러가기</Button>
                    </CardContent>
                </Card>
            </Grid>


            <Grid item sx={{width: '55%',  }}>
                <Card sx={{height: 826, overflow: 'auto', boxShadow:'none'}}>
                    <CardContent className={styles.emptyCardContent}>
                        <ErrorIcon className={styles.emptyIcon}/>
                        <Typography className={styles.emptyElements}>아직 생성된</Typography>
                        <Typography className={styles.emptyElements}>카테고리가 없어요</Typography>
                    </CardContent>
                </Card>
            </Grid>

            <Dialog open={open}>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                       스크랩 기능을 사용하기 위해서는 로그인이 필요합니다.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={agreeClick} autoFocus>로그인하러 가기</Button>
                </DialogActions>
            </Dialog>
        </>
    )
};

export default EmptyBookmark;